var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-query"},[_c('OtherQuery',{attrs:{"otherQueryParams":_vm.otherQueryParams}}),_c('SelectData',{attrs:{"dimensionCheckList":_vm.dimensionCheckList,"conditionCheckList":_vm.conditionCheckList,"fieldsCheckList":_vm.fieldsCheckList,"fieldsList":_vm.fieldsList,"dimensionList":_vm.dimensionList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }